import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class HealthPrivacy extends Component {

    render() {
        const data = Data.healthPrivacy;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/healthChina/healthPrivacy.js